import React, { useState, useRef } from 'react'
import className from 'classnames/bind'

import style from './MyhouseTooltipLayer.module.scss'

import innerHtml from '@Root/utils/innerHtml'
import IconTooltip from '@Ui/images/myhouse/IconTooltip'
import IconClose15x15 from '@Root/ui/images/myhouse/IconClose15x15.svg'
import { handleNclick } from '@Helpers/nclick'

const cx = className.bind(style)

export enum TooltipPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
}

type Props = {
  title?: any
  description?: any
  position?: TooltipPosition
  isInfo?: any
  infoLabel?: any
  infoDate?: any
  isSetting?: any
  nclickOpen?: string
}

const MyhouseTooltipLayer: React.FC<Props> = ({ title, description, position = TooltipPosition.TOP, isInfo, infoLabel, infoDate, isSetting, nclickOpen }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  const tooltipLayer = useRef(null)
  const tooltipButton = useRef(null)

  const handleTooltipToggle = (event: React.SyntheticEvent) => {
    if (isOpen) {
      handleTooltipClose()
    } else {
      nclickOpen && handleNclick(nclickOpen, event)
      setIsOpen(true)
      document.addEventListener('mousedown', handleClickOutside)
    }
  }

  const handleTooltipClose = () => {
    setIsOpen(false)
    document.removeEventListener('mousedown', handleClickOutside)
  }

  const handleClickOutside = (event: any) => {
    let ele = event.target
    while (true) {
      if (ele === tooltipLayer.current || ele === tooltipButton.current || ele.id === 'trend_price_close_button') {
        break
      } else if (ele.id === 'wrap' || ele.nodeName.toUpperCase() === 'BODY') {
        handleTooltipClose()
        break
      }
      ele = ele.parentNode
    }
  }

  return (
    <>
      <button ref={tooltipButton} type="button" className={cx('button_tooltip')} onClick={handleTooltipToggle}>
        <span className="blind">자세히 보기</span>
        <IconTooltip width="20" height="20" fill="#9da9bf" stroke="#9da9bf" />
      </button>
      {isOpen && (
        <div ref={tooltipLayer} className={cx('layer', isSetting && 'type_setting', position && `position_${position}`)}>
          <strong className={cx('title')}>{title}</strong>
          <p className={cx('description')} {...innerHtml(description)}></p>
          {isInfo && (
            <span className={cx('trade')}>
              거래 가능일<em className={cx('date')}>{isInfo}부터</em>
            </span>
          )}
          <button type="button" className={cx('button_close')} onClick={() => handleTooltipClose()}>
            <span className={cx('blind')}>닫기</span>
            <IconClose15x15 />
          </button>
        </div>
      )}
    </>
  )
}

export default MyhouseTooltipLayer
